import { createBrowserHistory, type History } from "history";

import { createWebviewHistoryWrapper, mobile } from "@btnet/utilities-webview";

export interface IAppRouterHistoryOptions {
    basename?: string;
}

/**
 * Creates a browser history object that integrates with webview navigation.
 *
 * In webview context:
 * - Emits `window.onNavigationEvent()` BEFORE routing occurs for push/replace
 * - Delegates all back navigation to native `window.onGoBack()`
 *
 * Outside webview: Returns standard browser history with no modifications.
 */
export function createAppRouterHistory({ basename = "" }: IAppRouterHistoryOptions = {}): History {
    const baseHistory = createBrowserHistory({ basename });

    if (mobile.isWebview) {
        return createWebviewHistoryWrapper(baseHistory);
    }
    return baseHistory;
}
